import AlertaGuardado from 'components/comun/AlertaGuardado';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Modal, Row } from 'reactstrap'
import { apiDepartamentosService } from 'services/apiDepartamentosService';
import { showAppAlert } from "components/common/AppAlerts";

const DetalleDepartamento = () => {
  const {id} = useParams();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [comentarios, setComentarios] = useState("");
  const [personalMinimo, setPersonalMinimo] = useState(null);

  const [status, setStatus] = useState("")
  
  const handleSubmit = async (e) =>{
    e.preventDefault();
    const json = {
      nombre: nombre,
      direccion: direccion,
      comentarios: comentarios,
      personalMinimo: personalMinimo
    }
    const response = await apiDepartamentosService.putById(id, json);
    setStatus(response.message)
    await new Promise(resolve => setTimeout(resolve, 2000));
    setStatus("")
  }

  const handleDelete = async (e) => {
    e.preventDefault();
   
    const response = await apiDepartamentosService.deleteById(id);
    if(response.message === "saved"){
      showAppAlert("Se ha eliminado correctamente", "success");
      navigate("/admin/departamentos")
    }else{
      showAppAlert("No se ha podido eliminar, hay elementos enlazados.", "error")
    }
  
  }

  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  useEffect(() => {
    const fetchData = async () =>{
        const response = await apiDepartamentosService.getById(id)
        setNombre(response.nombre)
        setDireccion(response.direccion)
        setComentarios(response.comentarios)
        setPersonalMinimo(response.personalMinimo)

    }

    fetchData();
  }, [id])
  

  return (
    <>
    <Card>
      <Form onSubmit={handleSubmit}>
        <CardHeader>
          Departamento: 
        </CardHeader>
        <CardBody>
          <Row>
            <Col lg={12}>
              <FormGroup>
                <Label htmlFor="nombre" className="form-control-label">
                  Nombre:
                </Label>
                <Input
                  type="text"
                  name="nombre"
                  className="form-control-alternative"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                ></Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label htmlFor="direccion" className="form-control-label">
                  Dirección:
                </Label>
                <Input
                  type="text"
                  name="direccion"
                  className="form-control-alternative"
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                ></Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label htmlFor="comentarios" className="form-control-label">
                  Comentarios:
                </Label>
                <Input
                  type="textarea"
                  name="comentarios"
                  className="form-control-alternative"
                  value={comentarios}
                  onChange={(e) => setComentarios(e.target.value)}
                ></Input>
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <Label htmlFor="personalMinimo" className="form-control-label">
                  Personal mínimo diario:
                </Label>
                <Input
                  type="number"
                  name="personalMinimo"
                  className="form-control-alternative"
                  min={1}
                  max={9999}
                  value={personalMinimo}
                  onChange={(e) => setPersonalMinimo(e.target.value)}
                ></Input>
              </FormGroup>
            </Col>

          </Row>
        </CardBody>
        <CardHeader className='text-right'>
          <Button color='success' type='submit'>Guardar</Button>
          <Button color='danger' onClick={toggleModal}>Eliminar</Button>
          <Button color='secondary' onClick={() => navigate("/admin/departamentos")}>Volver</Button>
        </CardHeader>
      </Form>
      
    </Card>

    <AlertaGuardado status={status}></AlertaGuardado>
    <Modal
        className="modal-dialog-centered"
        isOpen={modalOpen}
      >
        <div className="modal-header">
          <h2 className="modal-title" id="exampleModalLabel">
            ¿Está seguro que quiere eliminarlo?
          </h2>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>x</span>
          </button>
        </div>
        <div className="modal-body text-right">

          <Button  color='danger' onClick={handleDelete}>Sí</Button>
          <Button  color='secondary' onClick={() => toggleModal()}>No</Button>
        </div>

      </Modal>
    </>
  )
}

export default DetalleDepartamento


